import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import MatchingQuestion from '../../../components/Questions/MatchingQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const questions = {
    //title: 'Question 8: Referral Components',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Match each component to a sample statement you may use when referring someone. (click or tap on an item in the left column, then match it by clicking or tapping on its related example in the right column)`}
        />
        <strong>
          Match each component to a sample statement when referring someone.
        </strong>
        <br />
        (click component box in left column, then click matching statement in right column)
      </Fragment>
    ),
    feedback: {
      correct:
        'Correct! These are just some of the many ways that you can Acknowledge, Share, Explain, and Follow Up. The key is to convey these sentiments in an authentic way and tailored to the student’s specific context.'
    }
  };
  const options = [
    {
      prefix: 'E',
      matching: 'L',
      optionText: 'Acknowledge your limitations'
    },
    {
      prefix: 'D',
      matching: 'I',
      optionText:
        '“This resource offers mental health services, is confidential, and is covered by your insurance.”'
    },
    {
      prefix: 'G',
      matching: 'F',
      optionText: 'Share resource options'
    },
    
    {
      prefix: 'F',
      matching: 'G',
      optionText:
        '“Here are a few options on- and off-campus that people have found helpful.”'
    },
    
    {
      prefix: 'I',
      matching: 'D',
      optionText: 'Explain what to expect'
    },
    {
      prefix: 'J',
      matching: 'K',
      optionText: '“How are you doing? I came across some resources that I wanted to share.”'
    },
    {
      prefix: 'K',
      matching: 'J',
      optionText: 'Follow-up and offer further referrals'
    },
    {
      prefix: 'L',
      matching: 'E',
      optionText:
        '“I want to help but don\'t have the expertise.”'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={8}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text={`Let’s review REFER`} />
              <h2 className="txt-blue no-bold no-margin">Let’s review REFER</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`The most effective referrals typically include the components we just learned. These include: Acknowledge Limitations, Share Resources and Services, Explain and Follow Up. Practice your learning in the following activity.`}
              />
              <p>
                The most effective referrals include the following components:
                These include: <strong>Acknowledge Limitations, Share Resources and Services, 
                Explain and Follow Up.</strong> Practice your learning in the following activity.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <MatchingQuestion
        options={options}
        questions={questions}
        nextRoute={url.REFER_I}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferH = connect.role(ReferPage);

export default ReferH;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferH/index.jsx